module.exports = __webpack_public_path__ + "public/img/shangyue.e10105df.png";